import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import $ from "jquery";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AssignTask } from '../classes/assign-task';
import { AppConfiguration } from '../classes/configuration';
import { DriverTask } from '../classes/driver-task';
import { Events } from '../classes/events';
import { TaskAssignedFrom } from '../classes/task-assigned-from-enum';
import { EDGEWOOD, TERMINAL_LATLNG } from '../common/constants';
import { TaskType } from '../common/task-types';
import { ConfigurationService } from './configuration.service';
import { EventsDeltaService } from './events-delta.service';
import { EventsService } from './events.service';
import { LoggerService } from './logger.service';
import { MapIconService } from './map-icon.service';
import { MapPopUpService } from './map-popup.service';
import { ProfileService } from './profile.service';
import { ToastService } from './toast.service';
declare let L;
@Injectable({
  providedIn: 'root'
})
export class TaskMarkersService{

  constructor(
    private mapIconService: MapIconService,
    private mapPopUpService: MapPopUpService,
    private logger: LoggerService,
    private profileService: ProfileService,
    private http: HttpClient,
    private configurationService: ConfigurationService,
    private eventsDeltaService: EventsDeltaService,
    private eventsService: EventsService,
    private toastService: ToastService
  ) {
    this.subscribeToConfiguration();
   }


  configuration: AppConfiguration;
  unsubscribe$: Subject<boolean> = new Subject();
  markerToDelete: any;

  updateCount = 0;
  addedCount = 0;
  removedCount = 0;

  driverTaskLayerGroup: L.LayerGroup = new L.LayerGroup();
  driverTaskMarkersOnMap = {};

  unassignedTaskLayerGroup: L.LayerGroup = new L.LayerGroup();
  unassignedTaskMarkersOnMap = {};

  processUnassignedTaskMarkers(data: Events): L.LayerGroup{
    this.updateCount = 0;
    this.addedCount = 0;
    this.removedCount = 0;
    let unassignedTasks: DriverTask[] = data.unassignedTasks || [];
    if(unassignedTasks.length){
      unassignedTasks.forEach((row: DriverTask) => {
        if(row.displayUnassignedMarker){
          const id = row.taskName;
          const pos = row.typeName === TaskType.TERMINAL ? TERMINAL_LATLNG : new L.LatLng(row.latitude, row.longitude);
          if(!this.unassignedTaskMarkersOnMap[id]){
            this.unassignedTaskMarkersOnMap[id] = this.makeUnassignedTaskMarker(row, pos);
            this.unassignedTaskLayerGroup.addLayer(this.unassignedTaskMarkersOnMap[id]);
            this.addedCount++;
          }else{
            this.unassignedTaskMarkersOnMap[id].setLatLng(pos).setPopupContent(this.mapPopUpService.makeUnassignedTaskPopup(row));
            this.updateCount++;
          }
       }
      });
    }
    const unassignedTaskLayerIds:Array<any> = this.getUnassignedTaskLayerIds();
    const unassignedTaskIds:Array<any> = this.getUnassignedTaskIds(unassignedTasks);
    this.deleteOldUnassignedTaskMarkers(unassignedTaskIds, unassignedTaskLayerIds);
    this.logger.debug(`Unassigned Markers: Added:${this.addedCount}|Updated:${this.updateCount}|Removed:${this.removedCount}`, 'markers');
    return this.unassignedTaskLayerGroup;
  }

  deleteOldUnassignedTaskMarkers(unassignedTaskIds:Array<any>, unassignedTaskLayerIds:Array<any>){
    const oldMarkers = unassignedTaskLayerIds.filter((o) => !unassignedTaskIds.some((i) => i.id === o.id));
    oldMarkers.forEach((marker) => {
      const id = marker.id;
      this.unassignedTaskLayerGroup.removeLayer(this.unassignedTaskMarkersOnMap[id]);
      delete this.unassignedTaskMarkersOnMap[id];
      this.removedCount++;
    });
  }

  getUnassignedTaskLayerIds(): Array<any>{
    let unassignedTaskLayerIds = [];
    this.unassignedTaskLayerGroup.eachLayer((layer: any) => {
      const id = {'id': layer.options.taskId};
      unassignedTaskLayerIds.push(id)
    });
    return unassignedTaskLayerIds;
  }

  getUnassignedTaskIds(unassignedTasks: DriverTask[]): Array<any>{
    let unassignedTaskIds = [];
    unassignedTasks.forEach((row: DriverTask) => {
      const id = {'id': row.taskName};
      unassignedTaskIds.push(id);
    });
    return unassignedTaskIds;
  }

  makeUnassignedTaskMarker(unassignedTask: DriverTask, pos: L.LatLng): L.Marker{
    const marker = new L.Marker(pos, {
      icon: this.mapIconService.makeUnassignedTaskMarkerIcon(),
      taskId: unassignedTask.taskName,
      markerType: 'unassigned',
      zIndexOffset: -99
    });
    marker.bindPopup(this.mapPopUpService.makeUnassignedTaskPopup(unassignedTask));
    marker.on("popupopen", this.onPopupOpen);
    return marker;
  }


  onPopupOpen() { // To remove marker on click of delete
    this.markerToDelete = this || null;
  }





  /* Driver Primary and Secondary Task Markers **/
  processTaskMarkers(data: Events): L.LayerGroup{

    let driverTasks: DriverTask[] = data.driverTasks || [];
    const adId = this.profileService.profileObs$.getValue().adId.toLocaleUpperCase();

    this.driverTaskLayerGroup.eachLayer((layer) => {
      if(layer['options']['markerType'] === 'primary'){
        if(driverTasks[0]?.taskName !== layer['options']['taskId'] || driverTasks[0]?.taskName === undefined){
          this.removeTaskMarker(layer['options']['taskId']);
        }
      }
      if(layer['options']['markerType'] === 'second'){
        if(driverTasks[1]?.taskName !== layer['options']['taskId'] || driverTasks[1]?.taskName === undefined){
          this.removeTaskMarker(layer['options']['taskId']);
        }
      }
    });


    if(driverTasks.length > 0){
      const primaryTaskAssignTo = driverTasks[0].assignTo || '';
      if(primaryTaskAssignTo.toLocaleUpperCase() === adId){
        const id = driverTasks[0].taskName;
        const typeName = driverTasks[0].typeName || '';
        const pos = this.setPos(typeName, driverTasks[0]);
        if(!this.driverTaskMarkersOnMap[id]){
         this.driverTaskMarkersOnMap[id] = this.makeDriverTaskMarker(driverTasks[0], pos, 'primary');
         this.driverTaskLayerGroup.addLayer(this.driverTaskMarkersOnMap[id]);
        }
      }
    }

    if(driverTasks.length > 1){
      const secondTaskAssignTo = driverTasks[1].assignTo || '';
      if(secondTaskAssignTo.toLocaleUpperCase() === adId){
        const id = driverTasks[1].taskName;
        const typeName = driverTasks[1].typeName || '';
        const pos = this.setPos(typeName, driverTasks[1]);
        if(!this.driverTaskMarkersOnMap[id]){
          this.driverTaskMarkersOnMap[id] = this.makeDriverTaskMarker(driverTasks[1], pos, 'second');
          this.driverTaskLayerGroup.addLayer(this.driverTaskMarkersOnMap[id]);
        }
      }
    }
    return this.driverTaskLayerGroup;
  }


  setPos(typeName: string, task: DriverTask): any {
    let pos;
    switch(typeName){
      case "Terminal":
        pos = TERMINAL_LATLNG
        break;
      case "RemoteParking":
        pos = EDGEWOOD
        break;
      case "Other":
        pos = new L.LatLng(task.dropOffLatitude, task.dropOffLongitude);
        break;
      default:
        pos = new L.LatLng(task.latitude, task.longitude);
        break;
    }
    return pos;
  }


  makeDriverTaskMarker(driverTask: DriverTask, pos: L.LatLng, primaryOrSecond: string): L.Marker{
    const marker = new L.Marker(pos, {
      icon: this.mapIconService.makeDriverTaskMarkerIcon(primaryOrSecond),
      taskId: driverTask.taskName,
      markerType: primaryOrSecond,
      zIndexOffset: 10000
    });
    marker.bindPopup(this.mapPopUpService.makeDriverTaskPopup(driverTask));
    marker.on("popupopen", this.onPopupOpen);
    return marker;
  }


  removeTaskMarker(id): void{
    this.driverTaskLayerGroup.eachLayer((layer: any) => {
      const _id = layer.options.taskId;
      if(_id === id){
        this.driverTaskLayerGroup.removeLayer(layer);
        delete this.driverTaskMarkersOnMap[id];
      }
    });
  }

  removeUnassignedTaskMarker(id): void{
    this.unassignedTaskLayerGroup.eachLayer((layer: any) => {
      const _id = layer.options.taskId;
      if(_id === id){
        this.unassignedTaskLayerGroup.removeLayer(layer);
        delete this.unassignedTaskMarkersOnMap[id];
      }
    });
  }



  assignTask(tskId, assignFrom): void{
    const component = this; // <-- used to access angular zone from jquery
    const tskIds = [];
    tskIds.push(tskId);
    const profile = this.profileService.profileObs$.getValue();
    const adId = profile.adId || '?';
    if (!this.eventsService.driverHasVan(adId)) {
      this.toastService.show('You do not have a van assigned. Please get a van before assign tasks.', { classname: 'bg-danger text-light', delay: 8000 });
      return;
    }
    const assignTaskPayload: AssignTask = {taskIds: tskIds, assignTo: adId, type: 'assign'};
    const url = this.configuration.HostApi.concat('/task/'+tskId);
    const headers = { "Content-type": "application/json; charset=utf-8" };
    this.http.put<any>(url, JSON.stringify(assignTaskPayload), { headers, observe: "response" })
      .subscribe({
        next: (resp) => {
        this.logger.debug(`PUT AssignTask response: ${resp.status} ${resp.statusText}`, 'http');
        if(assignFrom === TaskAssignedFrom.AssignFromMarkerPopup){
          $('#buttonAssignTaskFromMarker_' + tskId).replaceWith('<div class="alert alert-success">Task Assigned</div>');
          setTimeout(function () {
            component.removeUnassignedTaskMarker(tskId);
          }, 400);
        }
        this.eventsDeltaService.getDeltas();
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === 409 && err.error?.reason === 'DRIVER_HAS_NO_VAN') {
            this.toastService.show('Selected driver does not have a van assigned.', { classname: 'bg-danger text-light', delay: 8000 });
          } else {
            this.toastService.show('HTTP Error Occurred!', { classname: 'bg-danger text-light', delay: 8000 });
          }
          this.logger.error(`PUT AssignTask error: ${err.status} ${err.statusText}`, 'http');
        }
      });
  }

  subscribeToConfiguration(): void {
    this.configurationService.getConfiguration()
      .pipe(
        takeUntil(this.unsubscribe$))
      .subscribe((configuration) => {
        this.configuration = configuration;
      });
  }


}
